module.exports = __webpack_public_path__ + "img/howto_pc.db54edeb.png";